import { Container, Typography, Grid } from "@mui/material";
import "./footer.scss";

export default function Footer() {
  return (
    <div className="footer-wrapper">
      <Container>
        <div className="footer">
          <div className="footer-visitors">
            {/* <iframe
              scrolling="no"
              frameBorder="0"
              width="220"
              height="220"
              src="globe.html"
              title="globe"
            ></iframe> */}
            <div class="col-md-2 footer-grids">
              <h3>Global Visitors</h3>
              <iframe
                scrolling="no"
                frameborder="0"
                width="220"
                height="220"
                // src="//rf.revolvermaps.com/w/8/a/a2.php?i=5vipbxp4ogn&amp;m=0&amp;c=ff0000&amp;cr1=ffffff&amp;f=arial&amp;l=33"
                src="./globe.html"
              >
                {/* //rf.revolvermaps.com/w/1/a/a2.php?i=5ft2zulcgk2&s=220&m=0&v=false&r=false&b=000000&n=false&c=ff0000 */}
              </iframe>

              {/* <script
                type="text/javascript"
                src="//rf.revolvermaps.com/0/0/1.js?i=5vipbxp4ogn&amp;s=220&amp;m=0&amp;v=false&amp;r=false&amp;b=000000&amp;n=false&amp;c=ff0000"
                async="async"
              ></script> */}
              {/* src="//rf.revolvermaps.com/w/8/a/a2.php?i=0settggap27&m=0&c=ff0000&cr1=ffffff&f=arial&l=33" */}
            </div>
          </div>
          <div className="footer-contact-us">
            <Grid container direction="column" spacing={4}>
              <Grid item>
                <Typography variant="p" lineHeight={1.5} align={"justify"}>
                  DeepPEP is a user-friendly interpretable deep-learning
                  platform for detecting peptides and predicting their
                  structures and functions in an automated pipeline. You are
                  welcome to communicate with us on the use of the problem,
                  which will help us to further improve our work.
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="p" component="div" lineHeight={1.5}>
                  <a
                    href="http://wei-group.net"
                    style={{ color: "white" }}
                    underline={false}
                  >
                    © 2022 Wei Lab | Contact us: weileyi@sdu.edu.cn
                  </a>
                </Typography>
                <Typography variant="p" component="div" lineHeight={1.5}>
                  This website is free and open to all users and there is no
                  login requirement.
                </Typography>
              </Grid>
            </Grid>
          </div>
        </div>
      </Container>
    </div>
  );
}
